

<template>
<v-tabs fixed centered>
  <v-tabs-bar class="blue lighten-1" dark>
    <v-tabs-slider class="yellow"></v-tabs-slider>
    <v-tabs-item v-for="(item, i) in items" :key="i" :href="'#tab-' + i">
      {{ item.text }}
    </v-tabs-item>
  </v-tabs-bar>
  <v-tabs-items>
    <v-tabs-content id="tab-0">
      <v-card flat>
        <v-card-title primary-title>Ihre Zugangsdaten zum Online-Portal</v-card-title>
        <v-card-text>
          <v-text-field v-model="account.username" label="Benutzername"></v-text-field>
          <v-text-field v-model="account.email" label="E-Mail-Adresse"></v-text-field>
          <v-checkbox v-model="account.changepwd" label="Passwort ändern" />
          <v-text-field v-if="account.changepwd" label="Passwort" v-model="account.password" :append-icon="e1 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e1 = !e1)" :type="e1 ? 'password' : 'text'" required></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="updateAccount">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-tabs-content>
    <v-tabs-content id="tab-1">
      <v-card flat>
        <v-card-title primary-title>Kundendaten bearbeiten</v-card-title>
        <v-card-text>
        </v-card-text>
      </v-card>
    </v-tabs-content>
  </v-tabs-items>
</v-tabs>
</template>

<script>
export default {
  data() {
    return {
      account: {
        username: '',
        email: '',
        password: '',
        changepwd: false
      },
      e1: true,
      items: [{
        icon: 'dashboard',
        text: 'Onlinezugang',
        link: '/Overview'
      }, {
        icon: 'exit_to_app',
        text: 'Kundenkonto',
        link: '/Logout'
      }]
    }
  },
  created() {
    this.$api.user.accountGetInfo().then((response) => {
      this.account = response.data
    })
  },
  methods: {
    updateAccount: function(event) {
      this.$api.user.accountUpdate(
        this.account
      ).then((response) => {
        this.$appData.account.username = this.account.username
        this.$appData.account.email = this.account.email
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// AccountOverview.vue?2dc5b8d7